import React from 'react';

export const LeaderPortrait = ({ leader, className = '', eager = false }) => (
  <picture className={className}>
    <source srcSet={leader.photo} type="image/webp" />
    <img
      src={leader.photoFallback}
      alt={`${leader.name}, ${leader.role} of CHIRE`}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      style={{ objectPosition: leader.photoPosition }}
      data-testid={`leader-photo-${leader.id}`}
    />
  </picture>
);

export default LeaderPortrait;
